module.exports = __webpack_public_path__ + "media/newstyle/images/bradesco-1f3b5ebd2fe897308973f2b26323c1f4.svg";